/**
 * Date helpers for date-only fields (issue date, due date, payment date).
 *
 * Do NOT use `new Date().toISOString().slice(0, 10)` for a default date. That
 * returns the *UTC* calendar day, and this app's users are in Asia/Colombo
 * (+05:30), so between 00:00 and 05:29 local it silently yields yesterday —
 * back-dating an invoice or payment into the previous day, and potentially the
 * previous VAT period at a month boundary.
 */

/** Today as 'YYYY-MM-DD' in the user's local calendar. */
export function todayLocalISO(): string {
  return toLocalISO(new Date());
}

/** Any Date -> 'YYYY-MM-DD' using its local calendar parts. */
export function toLocalISO(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** Today shifted by `days`, as 'YYYY-MM-DD' local (e.g. a +30 day due date). */
export function localISOPlusDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return toLocalISO(d);
}
